import type { ButtonClickEvent } from '@hc-frontend/core-ui';
import {
  Button,
  SpinnerInline,
  useEventBus,
  useTrackingContexts,
} from '@hc-frontend/core-ui';
import type { MouseEventHandler } from 'react';

import type {
  SendMetricEvent,
  SendMetricEventTarget,
} from '../../atoms/metrics-subscription';
import type { ButtonWithTrackingProps } from './button-with-tracking.types';

export function ButtonWithTracking({
  id,
  onClick,
  metricTags,
  children,
  isLoading = false,
  ...props
}: ButtonWithTrackingProps) {
  const eventBus = useEventBus();

  const contexts = useTrackingContexts();

  const handleClick: MouseEventHandler<HTMLButtonElement> = (event) => {
    const idToSend = id ?? 'without-id';
    const additionalMetricTags = {
      click_action: idToSend,
      platform: 'apollo',
      ...metricTags,
    };

    eventBus.publish<SendMetricEvent, SendMetricEventTarget>({
      id: idToSend,
      topic: 'metric.client.message',
      source: event.currentTarget,
      metric: {
        name: 'click',
        tags: additionalMetricTags,
      },
    });

    eventBus.publish<ButtonClickEvent>({
      id: idToSend,
      topic: 'core.ui.button.click',
      source: event.currentTarget,
      contexts,
    });

    onClick?.(event);
  };

  return (
    <Button {...props} id={id} onClick={handleClick}>
      {' '}
      {children}
      {isLoading ? <SpinnerInline /> : null}
    </Button>
  );
}
